var language = lang === null ? 'en' : lang;

// First bar chart - Top Color
window.showCharts = function(
    TopColor,
    Sum5,
    OddEven,
    First_Color,
    First_Sum,
    First_OddEven,
    Last_Color,
    Last_Sum,
    Last_OddEven
) {
var ctx = document.getElementById('myChart1').getContext('2d');
var chart = new Chart(ctx, {
    // The type of chart we want to create
    type: 'bar',

    // The data for our dataset
    data: {
        labels: [langArr[language].red, langArr[language].green, langArr[language].blue, langArr[language].purple, langArr[language].brown, langArr[language].yellow, langArr[language].orange, langArr[language].black],
        datasets: [{
                label: langArr[language].top_color,
                backgroundColor: [
                    '#c00f0f',
                    '#349a37',
                    '#0a66ae',
                    '#6d05d2',
                    '#965b17',
                    '#cfdc09',
                    '#f69504',
                    '#747473'

                ],
                data: TopColor, // - "Top Collor"
            }]
    },

    // Configuration options go here
    options: {
        scales:
                {
                    xAxes: [{
                            display: false
                        }],
                    yAxes: [{
                            gridLines: {
                                color: "#646464"
                            }
                        }]
                },
        legend: {
            display: false
        }
    }
});

// Chart 1 - First 5 Balls 1st chart
Chart.pluginService.register({
    afterUpdate: function (chart) {
        if (chart.config.options.elements.center) {
            var helpers = Chart.helpers;
            var centerConfig = chart.config.options.elements.center;
            var globalConfig = Chart.defaults.global;
            var ctx = chart.chart.ctx;

            var fontStyle = helpers.getValueOrDefault(centerConfig.fontStyle, globalConfig.defaultFontStyle);
            var fontFamily = helpers.getValueOrDefault(centerConfig.fontFamily, globalConfig.defaultFontFamily);

            if (centerConfig.fontSize)
                var fontSize = centerConfig.fontSize;
            // Figure out the best font size, if one is not specified
            else {
                ctx.save();
                var fontSize = helpers.getValueOrDefault(centerConfig.minFontSize, 1);
                var maxFontSize = helpers.getValueOrDefault(centerConfig.maxFontSize, 256);
                var maxText = helpers.getValueOrDefault(centerConfig.maxText, centerConfig.text);

                do {
                    ctx.font = helpers.fontString(fontSize, fontStyle, fontFamily);
                    var textWidth = ctx.measureText(maxText).width;

                    // Check if it fits, is within configured limits and that we are not simply toggling back and forth
                    if (textWidth < chart.innerRadius * 2 && fontSize < maxFontSize)
                        fontSize += 1;
                    else {
                        // Reverse last step
                        fontSize -= 1;
                        break;
                    }
                } while (true)
                ctx.restore();
            }

            // Save properties
            chart.center = {
                font: helpers.fontString(fontSize, fontStyle, fontFamily),
                fillStyle: helpers.getValueOrDefault(centerConfig.fontColor, globalConfig.defaultFontColor)
            };
        }
    },
    afterDraw: function (chart) {
        if (chart.center) {
            var centerConfig = chart.config.options.elements.center;
            var ctx = chart.chart.ctx;

            ctx.save();
            ctx.font = chart.center.font;
            ctx.fillStyle = chart.center.fillStyle;
            ctx.textAlign = 'center';
            ctx.textBaseline = 'middle';
            var centerX = (chart.chartArea.left + chart.chartArea.right) / 2;
            var centerY = (chart.chartArea.top + chart.chartArea.bottom) / 2;
            ctx.fillText(centerConfig.text, centerX, centerY);
            ctx.restore();
        }
    },
})

var config = {
    type: 'doughnut',
    data: {
        labels: [
            langArr[language].more,
            langArr[language].less
        ],
        datasets: [{
                data: [Sum5, 100 - Sum5], // "Sum5"
                backgroundColor: [
                    "#35b514",
                    "#757474"
                ],
                borderColor: [
                    "#35b514",
                    "#757474"
                ]
            }]
    },
    options: {
        cutoutPercentage: 80,
        legend: {
            display: false
        },
        elements: {
            center: {
                // the longest text that could appear in the center
                maxText: '100%',
                text: '+/- 122.5',
                fontColor: '#757474',
                fontFamily: "'proxima-nova-regular",
                fontStyle: 'normal',
                fontSize: 18,
                // if a fontSize is NOT specified, we will scale (within the below limits) maxText to take up the maximum space in the center
                // if these are not specified either, we default to 1 and 256
                minFontSize: 1,
                maxFontSize: 256,
            }
        }
    }
};

var ctx = document.getElementById("myChartPie1").getContext("2d");
var myChart = new Chart(ctx, config);
document.getElementById('js-legend1').innerHTML = myChart.generateLegend();

// Chart 2 - First 5 Balls 2nd chart
Chart.pluginService.register({
    afterUpdate: function (chart) {
        if (chart.config.options.elements.center) {
            var helpers = Chart.helpers;
            var centerConfig = chart.config.options.elements.center;
            var globalConfig = Chart.defaults.global;
            var ctx = chart.chart.ctx;

            var fontStyle = helpers.getValueOrDefault(centerConfig.fontStyle, globalConfig.defaultFontStyle);
            var fontFamily = helpers.getValueOrDefault(centerConfig.fontFamily, globalConfig.defaultFontFamily);

            if (centerConfig.fontSize)
                var fontSize = centerConfig.fontSize;
            // figure out the best font size, if one is not specified
            else {
                ctx.save();
                var fontSize = helpers.getValueOrDefault(centerConfig.minFontSize, 1);
                var maxFontSize = helpers.getValueOrDefault(centerConfig.maxFontSize, 256);
                var maxText = helpers.getValueOrDefault(centerConfig.maxText, centerConfig.text);

                do {
                    ctx.font = helpers.fontString(fontSize, fontStyle, fontFamily);
                    var textWidth = ctx.measureText(maxText).width;

                    // check if it fits, is within configured limits and that we are not simply toggling back and forth
                    if (textWidth < chart.innerRadius * 2 && fontSize < maxFontSize)
                        fontSize += 1;
                    else {
                        // reverse last step
                        fontSize -= 1;
                        break;
                    }
                } while (true)
                ctx.restore();
            }

            // save properties
            chart.center = {
                font: helpers.fontString(fontSize, fontStyle, fontFamily),
                fillStyle: helpers.getValueOrDefault(centerConfig.fontColor, globalConfig.defaultFontColor)
            };
        }
    },
    afterDraw: function (chart) {
        if (chart.center) {
            var centerConfig = chart.config.options.elements.center;
            var ctx = chart.chart.ctx;

            ctx.save();
            ctx.font = chart.center.font;
            ctx.fillStyle = chart.center.fillStyle;
            ctx.textAlign = 'center';
            ctx.textBaseline = 'middle';
            var centerX = (chart.chartArea.left + chart.chartArea.right) / 2;
            var centerY = (chart.chartArea.top + chart.chartArea.bottom) / 2;
            ctx.fillText(centerConfig.text, centerX, centerY);
            ctx.restore();
        }
    },
})

var config = {
    type: 'doughnut',
    data: {
        labels: [
            langArr[language].less,
            langArr[language].more
        ],
        datasets: [{
                data: [100 - Sum5, Sum5], // "Sum5"
                backgroundColor: [
                    "#bf0f0f",
                    "#757474"
                ],
                borderColor: [
                    "#bf0f0f",
                    "#757474"
                ]
            }]
    },
    options: {
        cutoutPercentage: 80,
        legend: {
            display: false
        },
        elements: {
            center: {
                // the longest text that could appear in the center
                maxText: '100%',
                text: '+/- 122.5',
                fontColor: '#757474',
                fontFamily: "'proxima-nova-regular",
                fontStyle: 'normal',
                fontSize: 18,
                // if a fontSize is NOT specified, we will scale (within the below limits) maxText to take up the maximum space in the center
                // if these are not specified either, we default to 1 and 256
                minFontSize: 1,
                maxFontSize: 256,
            }
        }
    }
};

var ctx = document.getElementById("myChartPie2").getContext("2d");
var myChart = new Chart(ctx, config);
document.getElementById('js-legend2').innerHTML = myChart.generateLegend();

// Chart 3 - All of the balls 1st chart
Chart.pluginService.register({
    afterUpdate: function (chart) {
        if (chart.config.options.elements.center) {
            var helpers = Chart.helpers;
            var centerConfig = chart.config.options.elements.center;
            var globalConfig = Chart.defaults.global;
            var ctx = chart.chart.ctx;

            var fontStyle = helpers.getValueOrDefault(centerConfig.fontStyle, globalConfig.defaultFontStyle);
            var fontFamily = helpers.getValueOrDefault(centerConfig.fontFamily, globalConfig.defaultFontFamily);

            if (centerConfig.fontSize)
                var fontSize = centerConfig.fontSize;
            // figure out the best font size, if one is not specified
            else {
                ctx.save();
                var fontSize = helpers.getValueOrDefault(centerConfig.minFontSize, 1);
                var maxFontSize = helpers.getValueOrDefault(centerConfig.maxFontSize, 256);
                var maxText = helpers.getValueOrDefault(centerConfig.maxText, centerConfig.text);

                do {
                    ctx.font = helpers.fontString(fontSize, fontStyle, fontFamily);
                    var textWidth = ctx.measureText(maxText).width;

                    // check if it fits, is within configured limits and that we are not simply toggling back and forth
                    if (textWidth < chart.innerRadius * 2 && fontSize < maxFontSize)
                        fontSize += 1;
                    else {
                        // reverse last step
                        fontSize -= 1;
                        break;
                    }
                } while (true)
                ctx.restore();
            }

            // save properties
            chart.center = {
                font: helpers.fontString(fontSize, fontStyle, fontFamily),
                fillStyle: helpers.getValueOrDefault(centerConfig.fontColor, globalConfig.defaultFontColor)
            };
        }
    },
    afterDraw: function (chart) {
        if (chart.center) {
            var centerConfig = chart.config.options.elements.center;
            var ctx = chart.chart.ctx;

            ctx.save();
            ctx.font = chart.center.font;
            ctx.fillStyle = chart.center.fillStyle;
            ctx.textAlign = 'center';
            ctx.textBaseline = 'middle';
            var centerX = (chart.chartArea.left + chart.chartArea.right) / 2;
            var centerY = (chart.chartArea.top + chart.chartArea.bottom) / 2;
            ctx.fillText(centerConfig.text, centerX, centerY);
            ctx.restore();
        }
    },
})

var config = {
    type: 'doughnut',
    data: {
        labels: [
            langArr[language].odd,
            langArr[language].even
        ],
        datasets: [{
                data: [100 - OddEven, OddEven], // "OddEven":
                backgroundColor: [
                    "#bf0f0f",
                    "#757474"
                ],
                borderColor: [
                    "#bf0f0f",
                    "#757474"
                ]
            }]
    },
    options: {
        cutoutPercentage: 70,
        legend: {
            display: false
        },
        elements: {
            center: {
                // the longest text that could appear in the center
                maxText: '100%',
                text: langArr[language].odd+ (100 - OddEven) +'%', // "OddEven":
                fontColor: '#757474',
                fontFamily: "'proxima-nova-regular",
                fontStyle: 'normal',
                fontSize: 15,
                // if a fontSize is NOT specified, we will scale (within the below limits) maxText to take up the maximum space in the center
                // if these are not specified either, we default to 1 and 256
                minFontSize: 1,
                maxFontSize: 256,
            }
        }
    }
};

var ctx = document.getElementById("myChartPie3").getContext("2d");
var myChart = new Chart(ctx, config);

// Chart 4  - All of the balls 2nd chart
Chart.pluginService.register({
    afterUpdate: function (chart) {
        if (chart.config.options.elements.center) {
            var helpers = Chart.helpers;
            var centerConfig = chart.config.options.elements.center;
            var globalConfig = Chart.defaults.global;
            var ctx = chart.chart.ctx;

            var fontStyle = helpers.getValueOrDefault(centerConfig.fontStyle, globalConfig.defaultFontStyle);
            var fontFamily = helpers.getValueOrDefault(centerConfig.fontFamily, globalConfig.defaultFontFamily);

            if (centerConfig.fontSize)
                var fontSize = centerConfig.fontSize;
            // figure out the best font size, if one is not specified
            else {
                ctx.save();
                var fontSize = helpers.getValueOrDefault(centerConfig.minFontSize, 1);
                var maxFontSize = helpers.getValueOrDefault(centerConfig.maxFontSize, 256);
                var maxText = helpers.getValueOrDefault(centerConfig.maxText, centerConfig.text);

                do {
                    ctx.font = helpers.fontString(fontSize, fontStyle, fontFamily);
                    var textWidth = ctx.measureText(maxText).width;

                    // check if it fits, is within configured limits and that we are not simply toggling back and forth
                    if (textWidth < chart.innerRadius * 2 && fontSize < maxFontSize)
                        fontSize += 1;
                    else {
                        // reverse last step
                        fontSize -= 1;
                        break;
                    }
                } while (true)
                ctx.restore();
            }

            // save properties
            chart.center = {
                font: helpers.fontString(fontSize, fontStyle, fontFamily),
                fillStyle: helpers.getValueOrDefault(centerConfig.fontColor, globalConfig.defaultFontColor)
            };
        }
    },
    afterDraw: function (chart) {
        if (chart.center) {
            var centerConfig = chart.config.options.elements.center;
            var ctx = chart.chart.ctx;

            ctx.save();
            ctx.font = chart.center.font;
            ctx.fillStyle = chart.center.fillStyle;
            ctx.textAlign = 'center';
            ctx.textBaseline = 'middle';
            var centerX = (chart.chartArea.left + chart.chartArea.right) / 2;
            var centerY = (chart.chartArea.top + chart.chartArea.bottom) / 2;
            ctx.fillText(centerConfig.text, centerX, centerY);
            ctx.restore();
        }
    },
})

var config = {
    type: 'doughnut',
    data: {
        labels: [
            langArr[language].even,
            langArr[language].odd
        ],
        datasets: [{ 
                data: [OddEven, 100 - OddEven], // "OddEven":
                backgroundColor: [
                    "#308bbf",
                    "#757474"
                ],
                borderColor: [
                    "#308bbf",
                    "#757474"
                ]
            }]
    },
    options: {
        cutoutPercentage: 70,
        legend: {
            display: false
        },
        elements: {
            center: {
                // the longest text that could appear in the center
                maxText: '100%',
                text: langArr[language].even+OddEven+'%', // "OddEven":
                fontColor: '#757474',
                fontFamily: "'proxima-nova-regular",
                fontStyle: 'normal',
                fontSize: 15,
                // if a fontSize is NOT specified, we will scale (within the below limits) maxText to take up the maximum space in the center
                // if these are not specified either, we default to 1 and 256
                minFontSize: 1,
                maxFontSize: 256,
            }
        }
    }
};

var ctx = document.getElementById("myChartPie4").getContext("2d");
var myChart = new Chart(ctx, config);

// Second bar chart - First color
var ctx = document.getElementById('myChart2').getContext('2d');
var chart = new Chart(ctx, {
    // The type of chart we want to create
    type: 'bar',

    // The data for our dataset
    data: {
        labels: [langArr[language].red, langArr[language].green, langArr[language].blue, langArr[language].purple, langArr[language].brown, langArr[language].yellow, langArr[language].orange, langArr[language].black],
        datasets: [{
                label: langArr[language].first_ball,
                backgroundColor: [
                    '#c00f0f',
                    '#349a37',
                    '#0a66ae',
                    '#6d05d2',
                    '#965b17',
                    '#cfdc09',
                    '#f69504',
                    '#747473'

                ],
                data: First_Color, // "First_Color"
            }]
    },

    // Configuration options go here
    options: {
        scales:
                {
                    xAxes: [{
                            display: false
                        }],
                    yAxes: [{
                            gridLines: {
                                color: "#646464"
                            }
                        }]
                },
        legend: {
            display: false

        }
    }
});

// Chart 5 - First ball 1st chart
Chart.pluginService.register({
    afterUpdate: function (chart) {
        if (chart.config.options.elements.center) {
            var helpers = Chart.helpers;
            var centerConfig = chart.config.options.elements.center;
            var globalConfig = Chart.defaults.global;
            var ctx = chart.chart.ctx;

            var fontStyle = helpers.getValueOrDefault(centerConfig.fontStyle, globalConfig.defaultFontStyle);
            var fontFamily = helpers.getValueOrDefault(centerConfig.fontFamily, globalConfig.defaultFontFamily);

            if (centerConfig.fontSize)
                var fontSize = centerConfig.fontSize;
            // figure out the best font size, if one is not specified
            else {
                ctx.save();
                var fontSize = helpers.getValueOrDefault(centerConfig.minFontSize, 1);
                var maxFontSize = helpers.getValueOrDefault(centerConfig.maxFontSize, 256);
                var maxText = helpers.getValueOrDefault(centerConfig.maxText, centerConfig.text);

                do {
                    ctx.font = helpers.fontString(fontSize, fontStyle, fontFamily);
                    var textWidth = ctx.measureText(maxText).width;

                    // check if it fits, is within configured limits and that we are not simply toggling back and forth
                    if (textWidth < chart.innerRadius * 2 && fontSize < maxFontSize)
                        fontSize += 1;
                    else {
                        // reverse last step
                        fontSize -= 1;
                        break;
                    }
                } while (true)
                ctx.restore();
            }

            // save properties
            chart.center = {
                font: helpers.fontString(fontSize, fontStyle, fontFamily),
                fillStyle: helpers.getValueOrDefault(centerConfig.fontColor, globalConfig.defaultFontColor)
            };
        }
    },
    afterDraw: function (chart) {
        if (chart.center) {
            var centerConfig = chart.config.options.elements.center;
            var ctx = chart.chart.ctx;

            ctx.save();
            ctx.font = chart.center.font;
            ctx.fillStyle = chart.center.fillStyle;
            ctx.textAlign = 'center';
            ctx.textBaseline = 'middle';
            var centerX = (chart.chartArea.left + chart.chartArea.right) / 2;
            var centerY = (chart.chartArea.top + chart.chartArea.bottom) / 2;
            ctx.fillText(centerConfig.text, centerX, centerY);
            ctx.restore();
        }
    },
})


var config = {
    type: 'doughnut',
    data: {
        labels: [
            langArr[language].more,
            langArr[language].less
        ],
        datasets: [{
                data: [First_Sum, 100 - First_Sum],
                backgroundColor: [
                    "#35b514",
                    "#757474"
                ],
                borderColor: [
                    "#35b514",
                    "#757474"
                ]
            }]
    },
    options: {
        cutoutPercentage: 80,
        legend: {
            display: false
        },
        elements: {
            center: {
                // the longest text that could appear in the center
                maxText: '100%',
                text: '+/- 24.5',
                fontColor: '#757474',
                fontFamily: "'proxima-nova-regular",
                fontStyle: 'normal',
                fontSize: 14,
                // if a fontSize is NOT specified, we will scale (within the below limits) maxText to take up the maximum space in the center
                // if these are not specified either, we default to 1 and 256
                minFontSize: 1,
                maxFontSize: 256,
            }
        }
    }
};

var ctx = document.getElementById("myChartPie5").getContext("2d");
var myChart = new Chart(ctx, config);
document.getElementById('js-legend5').innerHTML = myChart.generateLegend();

//Chart 6

Chart.pluginService.register({
    afterUpdate: function (chart) {
        if (chart.config.options.elements.center) {
            var helpers = Chart.helpers;
            var centerConfig = chart.config.options.elements.center;
            var globalConfig = Chart.defaults.global;
            var ctx = chart.chart.ctx;

            var fontStyle = helpers.getValueOrDefault(centerConfig.fontStyle, globalConfig.defaultFontStyle);
            var fontFamily = helpers.getValueOrDefault(centerConfig.fontFamily, globalConfig.defaultFontFamily);

            if (centerConfig.fontSize)
                var fontSize = centerConfig.fontSize;
            // figure out the best font size, if one is not specified
            else {
                ctx.save();
                var fontSize = helpers.getValueOrDefault(centerConfig.minFontSize, 1);
                var maxFontSize = helpers.getValueOrDefault(centerConfig.maxFontSize, 256);
                var maxText = helpers.getValueOrDefault(centerConfig.maxText, centerConfig.text);

                do {
                    ctx.font = helpers.fontString(fontSize, fontStyle, fontFamily);
                    var textWidth = ctx.measureText(maxText).width;

                    // check if it fits, is within configured limits and that we are not simply toggling back and forth
                    if (textWidth < chart.innerRadius * 2 && fontSize < maxFontSize)
                        fontSize += 1;
                    else {
                        // reverse last step
                        fontSize -= 1;
                        break;
                    }
                } while (true)
                ctx.restore();
            }

            // save properties
            chart.center = {
                font: helpers.fontString(fontSize, fontStyle, fontFamily),
                fillStyle: helpers.getValueOrDefault(centerConfig.fontColor, globalConfig.defaultFontColor)
            };
        }
    },
    afterDraw: function (chart) {
        if (chart.center) {
            var centerConfig = chart.config.options.elements.center;
            var ctx = chart.chart.ctx;

            ctx.save();
            ctx.font = chart.center.font;
            ctx.fillStyle = chart.center.fillStyle;
            ctx.textAlign = 'center';
            ctx.textBaseline = 'middle';
            var centerX = (chart.chartArea.left + chart.chartArea.right) / 2;
            var centerY = (chart.chartArea.top + chart.chartArea.bottom) / 2;
            ctx.fillText(centerConfig.text, centerX, centerY);
            ctx.restore();
        }
    },
})


var config = {
    type: 'doughnut',
    data: {
        labels: [
            langArr[language].odd,
            langArr[language].even
        ],
        datasets: [{
                data: [100 - First_OddEven, First_OddEven],
                backgroundColor: [
                    "#bf0f0f",
                    "#757474"
                ],
                borderColor: [
                    "#bf0f0f",
                    "#757474"
                ]
            }]
    },
    options: {
        cutoutPercentage: 70,
        legend: {
            display: false
        },
        elements: {
            center: {
                // the longest text that could appear in the center
                maxText: '100%',
                text: langArr[language].odd+ (100 - First_OddEven) +'%',
                fontColor: '#757474',
                fontFamily: "'proxima-nova-regular",
                fontStyle: 'normal',
                fontSize: 12,
                // if a fontSize is NOT specified, we will scale (within the below limits) maxText to take up the maximum space in the center
                // if these are not specified either, we default to 1 and 256
                minFontSize: 1,
                maxFontSize: 256,
            }
        }
    }
};

var ctx = document.getElementById("myChartPie6").getContext("2d");
var myChart = new Chart(ctx, config);

//Chart 7

Chart.pluginService.register({
    afterUpdate: function (chart) {
        if (chart.config.options.elements.center) {
            var helpers = Chart.helpers;
            var centerConfig = chart.config.options.elements.center;
            var globalConfig = Chart.defaults.global;
            var ctx = chart.chart.ctx;

            var fontStyle = helpers.getValueOrDefault(centerConfig.fontStyle, globalConfig.defaultFontStyle);
            var fontFamily = helpers.getValueOrDefault(centerConfig.fontFamily, globalConfig.defaultFontFamily);

            if (centerConfig.fontSize)
                var fontSize = centerConfig.fontSize;
            // figure out the best font size, if one is not specified
            else {
                ctx.save();
                var fontSize = helpers.getValueOrDefault(centerConfig.minFontSize, 1);
                var maxFontSize = helpers.getValueOrDefault(centerConfig.maxFontSize, 256);
                var maxText = helpers.getValueOrDefault(centerConfig.maxText, centerConfig.text);

                do {
                    ctx.font = helpers.fontString(fontSize, fontStyle, fontFamily);
                    var textWidth = ctx.measureText(maxText).width;

                    // check if it fits, is within configured limits and that we are not simply toggling back and forth
                    if (textWidth < chart.innerRadius * 2 && fontSize < maxFontSize)
                        fontSize += 1;
                    else {
                        // reverse last step
                        fontSize -= 1;
                        break;
                    }
                } while (true)
                ctx.restore();
            }

            // save properties
            chart.center = {
                font: helpers.fontString(fontSize, fontStyle, fontFamily),
                fillStyle: helpers.getValueOrDefault(centerConfig.fontColor, globalConfig.defaultFontColor)
            };
        }
    },
    afterDraw: function (chart) {
        if (chart.center) {
            var centerConfig = chart.config.options.elements.center;
            var ctx = chart.chart.ctx;

            ctx.save();
            ctx.font = chart.center.font;
            ctx.fillStyle = chart.center.fillStyle;
            ctx.textAlign = 'center';
            ctx.textBaseline = 'middle';
            var centerX = (chart.chartArea.left + chart.chartArea.right) / 2;
            var centerY = (chart.chartArea.top + chart.chartArea.bottom) / 2;
            ctx.fillText(centerConfig.text, centerX, centerY);
            ctx.restore();
        }
    },
})


var config = {
    type: 'doughnut',
    data: {
        labels: [
            langArr[language].even,
            langArr[language].odd
        ],
        datasets: [{
                data: [First_OddEven, 100 - First_OddEven],
                backgroundColor: [
                    "#308bbf",
                    "#757474"
                ],
                borderColor: [
                    "#308bbf",
                    "#757474"
                ]
            }]
    },
    options: {
        cutoutPercentage: 70,
        legend: {
            display: false
        },
        elements: {
            center: {
                // the longest text that could appear in the center
                maxText: '100%',
                text: langArr[language].even+First_OddEven+'%',
                fontColor: '#757474',
                fontFamily: "'proxima-nova-regular",
                fontStyle: 'normal',
                fontSize: 12,
                // if a fontSize is NOT specified, we will scale (within the below limits) maxText to take up the maximum space in the center
                // if these are not specified either, we default to 1 and 256
                minFontSize: 1,
                maxFontSize: 256,
            }
        }
    }
};

var ctx = document.getElementById("myChartPie7").getContext("2d");
var myChart = new Chart(ctx, config);

//Third bar chart

var ctx = document.getElementById('myChart3').getContext('2d');
var chart = new Chart(ctx, {
    // The type of chart we want to create
    type: 'bar',

    // The data for our dataset
    data: {
        labels: [langArr[language].red, langArr[language].green, langArr[language].blue, langArr[language].purple, langArr[language].brown, langArr[language].yellow, langArr[language].orange, langArr[language].black],
        datasets: [{
                label: langArr[language].last_ball,
                backgroundColor: [
                    '#c00f0f',
                    '#349a37',
                    '#0a66ae',
                    '#6d05d2',
                    '#965b17',
                    '#cfdc09',
                    '#f69504',
                    '#747473'

                ],
                data: Last_Color,
            }]
    },

    // Configuration options go here
    options: {
        scales:
                {
                    xAxes: [{
                            display: false
                        }],
                    yAxes: [{
                            gridLines: {
                                color: "#646464"
                            }
                        }]
                },
        legend: {
            display: false

        }
    }
});

// Chart 8
Chart.pluginService.register({
    afterUpdate: function (chart) {
        if (chart.config.options.elements.center) {
            var helpers = Chart.helpers;
            var centerConfig = chart.config.options.elements.center;
            var globalConfig = Chart.defaults.global;
            var ctx = chart.chart.ctx;

            var fontStyle = helpers.getValueOrDefault(centerConfig.fontStyle, globalConfig.defaultFontStyle);
            var fontFamily = helpers.getValueOrDefault(centerConfig.fontFamily, globalConfig.defaultFontFamily);

            if (centerConfig.fontSize)
                var fontSize = centerConfig.fontSize;
                // figure out the best font size, if one is not specified
            else {
                ctx.save();
                var fontSize = helpers.getValueOrDefault(centerConfig.minFontSize, 1);
                var maxFontSize = helpers.getValueOrDefault(centerConfig.maxFontSize, 256);
                var maxText = helpers.getValueOrDefault(centerConfig.maxText, centerConfig.text);

                do {
                    ctx.font = helpers.fontString(fontSize, fontStyle, fontFamily);
                    var textWidth = ctx.measureText(maxText).width;
                    // check if it fits, is within configured limits and that we are not simply toggling back and forth
                    if (textWidth < chart.innerRadius * 2 && fontSize < maxFontSize)
                        fontSize += 1;
                    else {
                        // reverse last step
                        fontSize -= 1;
                        break;
                    }
                } while (true)
                ctx.restore();
            }

            // save properties
            chart.center = {
                font: helpers.fontString(fontSize, fontStyle, fontFamily),
                fillStyle: helpers.getValueOrDefault(centerConfig.fontColor, globalConfig.defaultFontColor)
            };
        }
    },
    afterDraw: function (chart) {
        if (chart.center) {
            var centerConfig = chart.config.options.elements.center;
            var ctx = chart.chart.ctx;

            ctx.save();
            ctx.font = chart.center.font;
            ctx.fillStyle = chart.center.fillStyle;
            ctx.textAlign = 'center';
            ctx.textBaseline = 'middle';
            var centerX = (chart.chartArea.left + chart.chartArea.right) / 2;
            var centerY = (chart.chartArea.top + chart.chartArea.bottom) / 2;
            ctx.fillText(centerConfig.text, centerX, centerY);
            ctx.restore();
        }
    },
})

var config = {
    type: 'doughnut',
    data: {
        labels: [
            langArr[language].more,
            langArr[language].less
        ],
        datasets: [{
                data: [Last_Sum, 100 - Last_Sum],
                backgroundColor: [
                    "#35b514",
                    "#757474"
                ],
                borderColor: [
                    "#35b514",
                    "#757474"
                ]
            }]
    },
    options: {
        cutoutPercentage: 80,
        legend: {
            display: false
        },
        elements: {
            center: {
                // the longest text that could appear in the center
                maxText: '100%',
                text: '+/- 24.5',
                fontColor: '#757474',
                fontFamily: "'proxima-nova-regular",
                fontStyle: 'normal',
                fontSize: 14,
                // if a fontSize is NOT specified, we will scale (within the below limits) maxText to take up the maximum space in the center
                // if these are not specified either, we default to 1 and 256
                minFontSize: 1,
                maxFontSize: 256,
            }
        }
    }
};

var ctx = document.getElementById("myChartPie8").getContext("2d");
var myChart = new Chart(ctx, config);
document.getElementById('js-legend8').innerHTML = myChart.generateLegend();

// Chart 9
Chart.pluginService.register({
    afterUpdate: function (chart) {
        if (chart.config.options.elements.center) {
            var helpers = Chart.helpers;
            var centerConfig = chart.config.options.elements.center;
            var globalConfig = Chart.defaults.global;
            var ctx = chart.chart.ctx;

            var fontStyle = helpers.getValueOrDefault(centerConfig.fontStyle, globalConfig.defaultFontStyle);
            var fontFamily = helpers.getValueOrDefault(centerConfig.fontFamily, globalConfig.defaultFontFamily);

            if (centerConfig.fontSize)
                var fontSize = centerConfig.fontSize;
                // figure out the best font size, if one is not specified
            else {
                ctx.save();
                var fontSize = helpers.getValueOrDefault(centerConfig.minFontSize, 1);
                var maxFontSize = helpers.getValueOrDefault(centerConfig.maxFontSize, 256);
                var maxText = helpers.getValueOrDefault(centerConfig.maxText, centerConfig.text);

                do {
                    ctx.font = helpers.fontString(fontSize, fontStyle, fontFamily);
                    var textWidth = ctx.measureText(maxText).width;
                    // check if it fits, is within configured limits and that we are not simply toggling back and forth
                    if (textWidth < chart.innerRadius * 2 && fontSize < maxFontSize)
                        fontSize += 1;
                    else {
                        // reverse last step
                        fontSize -= 1;
                        break;
                    }
                } while (true)
                ctx.restore();
            }

            // save properties
            chart.center = {
                font: helpers.fontString(fontSize, fontStyle, fontFamily),
                fillStyle: helpers.getValueOrDefault(centerConfig.fontColor, globalConfig.defaultFontColor)
            };
        }
    },
    afterDraw: function (chart) {
        if (chart.center) {
            var centerConfig = chart.config.options.elements.center;
            var ctx = chart.chart.ctx;

            ctx.save();
            ctx.font = chart.center.font;
            ctx.fillStyle = chart.center.fillStyle;
            ctx.textAlign = 'center';
            ctx.textBaseline = 'middle';
            var centerX = (chart.chartArea.left + chart.chartArea.right) / 2;
            var centerY = (chart.chartArea.top + chart.chartArea.bottom) / 2;
            ctx.fillText(centerConfig.text, centerX, centerY);
            ctx.restore();
        }
    },
})

var config = {
    type: 'doughnut',
    data: {
        labels: [
            langArr[language].odd,
            langArr[language].even
        ],
        datasets: [{
                data: [100 - Last_OddEven, Last_OddEven],
                backgroundColor: [
                    "#bf0f0f",
                    "#757474"
                ],
                borderColor: [
                    "#bf0f0f",
                    "#757474"
                ]
            }]
    },
    options: {
        cutoutPercentage: 70,
        legend: {
            display: false
        },
        elements: {
            center: {
                // the longest text that could appear in the center
                maxText: '100%',
                text: langArr[language].odd+(100-Last_OddEven)+'%',
                fontColor: '#757474',
                fontFamily: "'proxima-nova-regular",
                fontStyle: 'normal',
                fontSize: 12,
                minFontSize: 1,
                maxFontSize: 256,
            }
        }
    }
};

var ctx = document.getElementById("myChartPie9").getContext("2d");
var myChart = new Chart(ctx, config);

// Chart 10
Chart.pluginService.register({
    afterUpdate: function (chart) {
        if (chart.config.options.elements.center) {
            var helpers = Chart.helpers;
            var centerConfig = chart.config.options.elements.center;
            var globalConfig = Chart.defaults.global;
            var ctx = chart.chart.ctx;

            var fontStyle = helpers.getValueOrDefault(centerConfig.fontStyle, globalConfig.defaultFontStyle);
            var fontFamily = helpers.getValueOrDefault(centerConfig.fontFamily, globalConfig.defaultFontFamily);

            if (centerConfig.fontSize)
                var fontSize = centerConfig.fontSize;
                // figure out the best font size, if one is not specified
            else {
                ctx.save();
                var fontSize = helpers.getValueOrDefault(centerConfig.minFontSize, 1);
                var maxFontSize = helpers.getValueOrDefault(centerConfig.maxFontSize, 256);
                var maxText = helpers.getValueOrDefault(centerConfig.maxText, centerConfig.text);

                do {
                    ctx.font = helpers.fontString(fontSize, fontStyle, fontFamily);
                    var textWidth = ctx.measureText(maxText).width;

                    // check if it fits, is within configured limits and that we are not simply toggling back and forth
                    if (textWidth < chart.innerRadius * 2 && fontSize < maxFontSize)
                        fontSize += 1;
                    else {
                        // reverse last step
                        fontSize -= 1;
                        break;
                    }
                } while (true)
                ctx.restore();
            }

            // save properties
            chart.center = {
                font: helpers.fontString(fontSize, fontStyle, fontFamily),
                fillStyle: helpers.getValueOrDefault(centerConfig.fontColor, globalConfig.defaultFontColor)
            };
        }
    },
    afterDraw: function (chart) {
        if (chart.center) {
            var centerConfig = chart.config.options.elements.center;
            var ctx = chart.chart.ctx;

            ctx.save();
            ctx.font = chart.center.font;
            ctx.fillStyle = chart.center.fillStyle;
            ctx.textAlign = 'center';
            ctx.textBaseline = 'middle';
            var centerX = (chart.chartArea.left + chart.chartArea.right) / 2;
            var centerY = (chart.chartArea.top + chart.chartArea.bottom) / 2;
            ctx.fillText(centerConfig.text, centerX, centerY);
            ctx.restore();
        }
    },
})

var config = {
    type: 'doughnut',
    data: {
        labels: [
            langArr[language].even,
            langArr[language].odd
        ],
        datasets: [{
                data: [Last_OddEven, 100 - Last_OddEven],
                backgroundColor: [
                    "#308bbf",
                    "#757474"
                ],
                borderColor: [
                    "#308bbf",
                    "#757474"
                ]
            }]
    },
    options: {
        cutoutPercentage: 70,
        legend: {
            display: false
        },
        elements: {
            center: {
                // the longest text that could appear in the center
                maxText: '100%',
                text: langArr[language].even+Last_OddEven+'%',
                fontColor: '#757474',
                fontFamily: "'proxima-nova-regular",
                fontStyle: 'normal',
                fontSize: 12,
                minFontSize: 1,
                maxFontSize: 256,
            }
        }
    }
};

var ctx = document.getElementById("myChartPie10").getContext("2d");
var myChart = new Chart(ctx, config);
}


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/js/charts.js
// module id = 850
// module chunks = 2